<button class="share-button" (click)="onButtonClick()">
  <span class="share-button__title" i18n>Download MP3 file</span>
  <span class="share-button__badge" *ngIf="processing === false">MP3</span>
  <span class="share-button__badge" *ngIf="processing" i18n>Processing</span>
</button>



// WEBPACK FOOTER //
// ./src/app/rec/components/share/share-download/share-download.component.html